import React, { useCallback, useEffect, useState, useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FJLoading from '../../components/FJLoading/FJLoading';
import FJVerticalScroller from '../../components/FJScroller/FJVerticalScroller';
import FJLocalStore from '../../../store/FJLocalStore';

import styles from './FJVirtualList.module.less';
const DEFAULT_PAGE_SIZE = 20;
const THRESHOLD = 50;

const FJVirtualList = ({ list = [], renderItem, className, pageSize = DEFAULT_PAGE_SIZE, renderPlaceHolder }, ref) => {
    const [displayItems, setDisplayItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [stateMaxCount, setStateMaxCount] = useState(pageSize);
    const [initialHasMore, setInitialHasMore] = useState(false);

    const hasMore = useMemo(() => stateMaxCount < list.length, [stateMaxCount, list.length]);

    // 初始化数据
    useEffect(() => {
        setInitialHasMore(pageSize < list.length);
        setStateMaxCount(pageSize);
        setDisplayItems(list.slice(0, pageSize));
    }, [pageSize, list]);

    // 处理滚动到底部事件
    const handleTotalScroll = useCallback(() => {
        if (!hasMore || isLoading) return;
        const _newMaxCount = stateMaxCount + pageSize;
        setStateMaxCount(_newMaxCount);

        setIsLoading(true);
        setDisplayItems(list.slice(0, _newMaxCount));
        setIsLoading(false);
    }, [pageSize, hasMore, isLoading, stateMaxCount]);

    return (
        <FJVerticalScroller
            ref={ref}
            className={classnames(styles.virtualList, className)}
            onTotalScroll={handleTotalScroll}
            totalScrollThreshold={THRESHOLD}
        >
            <div className={styles.content}>
                {displayItems.map((item, index) => (
                    <React.Fragment key={index}>{renderItem(item)}</React.Fragment>
                ))}
                {initialHasMore && (
                    <div className={styles.bottom}>
                        {isLoading && (
                            <div className={styles.loading}>
                                <FJLoading strokeColor='#a8acbc' />
                            </div>
                        )}
                        {!hasMore && <div className={styles.end}>{FJLocalStore._('scroll-end-tip')}</div>}
                    </div>
                )}
                {renderPlaceHolder?.()}
            </div>
        </FJVerticalScroller>
    );
};

FJVirtualList.propTypes = {
    list: PropTypes.array,
    renderItem: PropTypes.func.isRequired,
    className: PropTypes.string,
    pageSize: PropTypes.number,
    renderPlaceHolder: PropTypes.func,
};

export default forwardRef(FJVirtualList);
